import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

const defaultErrorMessage = $localize`Ein Fehler ist aufgetreten.`;

@Injectable({
	providedIn: 'root'
})
export class AlertService {

	constructor(private snackBar: MatSnackBar) {
	}

	alertError(error?: string): void {
		const message = error ? error : defaultErrorMessage;
		this.snackBar.open(message, '×', {
			duration: 2000,
			verticalPosition: 'top',
			panelClass: 'app-snackbar__error'
		});
	}

	alertInfo(info: string): void {
		this.snackBar.open(info, '×', {
			duration: 2000,
			verticalPosition: 'top',
			panelClass: 'app-snackbar__info'
		});
	}
}
